export default "__VITE_ASSET__bc9c99f0__"